<style lang="scss" scoped>
.speaker-card {
    border: none;
    color: inherit;
    display: block;
    margin: 0px;
    text-align: inherit;
    text-decoration: none;
    height: 100%;
    width: 100%;

    .media-container {
        border-radius: 4px;
        position: relative;
        overflow: hidden;

        .ar {
            position: relative;
            background-position: 50% 50%;
            background-repeat: no-repeat;

            .images {
                position: absolute;
                top: 0px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    border-radius: 4px;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    font-family: "object-fit: cover;";
                }

                .primary-image {
                    z-index: 9;
                }

                .crossfade-to-images {
                    position: absolute;
                    top: 0;
                    z-index: 10;
                }

                .crossfade-from-images {
                    position: absolute;
                    top: 0;
                    z-index: 11;
                }
            }
        }
    }

    .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }

    .subtitle {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
    }
}
</style>

<template>
    <a class="speaker-card" :href="route('nl.speaker', {slug: speaker.post_name})">
        <div class="media-container mb-12" ref="card">
            <div ref="ar" class="ar" :style="{ 'padding-top' : `${ arHeight / arWidth * 100 }%` }">
                <div class="images">
                    <template v-if="speaker.acf && speaker.acf.image">
                        <img class="primary-image" ref="primary" :src="speaker.acf.image.sizes.medium_large" :alt="speaker.post_title">
                    </template>
                </div>
            </div>
        </div>
        <p class="title lh-1">{{ speaker.post_title }}</p>
        <p v-if="speaker.acf && speaker.acf.highlighted_title && !$root.isMobile" class="text-dark font-weight-light small mt-8 subtitle">
            {{ speaker.acf.highlighted_title }}
        </p>
    </a>
</template>

<script>
export default {
    name: "elements.speaker-section-card",

    props: {
        speaker: {
            type: Object,
            required: true,
        },
        ratio: {
            type: [String, Boolean],
            default: '181:240',
            required: false
        },
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },
        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },
    }
}
</script>